import styled, { keyframes, createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html, body {
    background: #fff;

    & .header {
      height: 110px;
      @media screen and (orientation: portrait) {
        height: 60px;
        z-index: 100;
      }
    }
  }
`;

const scaleup = keyframes`
  0% { transform: scale(0) }
  100% { transform: scale(1.2)}
`;

export const ContentWrap = styled.section`
  display: flex;  
  align-items: center;
  flex-direction: column;
  padding: 15px;
  padding-top: 130px;
  box-sizing: border-box;
  row-gap: 50px;
  @media screen and (orientation: portrait) {
    padding: 12px;
    padding-top: 30px;
    row-gap: 35px;
  }

  & .sub_wrap {
    width: 100%;
  }

  & > .container {
    width: 100%;
    max-width: 750px;
    & > h5 {
      font-weight: 900;
      text-decoration: underline;
      color: #000;
      letter-spacing: 1px;
      text-transform: uppercase;
      padding-bottom: 12px;
      padding-left: 20px;
      box-sizing: border-box;
    }

    & > .products {
      width: 100%;

      & > .product {
        width: 100%;
        height: 55px;
        color: #000;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 1.5px;
        border-bottom: 1px solid rgba(0,0,0, 0.4);
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: 20px;
        padding-right: 20px;
        box-sizing: border-box;
        cursor: pointer;
        &:last-child {
          border-bottom: 0;
        }
      }
    }
  }

  & > .scrollAds {
    position: relative;
    width: 100%;
    max-width: 1600px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: auto;
    flex-direction: column;
    row-gap: 20px;

    & > a {
      display: flex;
    }

    & > h3 {
      font-size: 20px;
      @media screen and (orientation: portrait) {
        font-size: 15px;
      }
    }
    @media screen and (orientation: portrait) {
      justify-content: start-end;
    }
  }

  & > .service_title {
    width: 100%;
    max-width: 1600px;
    font-size: 27px;
    padding: 20px;
    border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    margin-bottom: -50px;
    box-sizing: border-box;
    text-align: center;
    font-weight: 300;
    @media screen and (orientation: portrait) {
      font-size: 23px;
      margin-bottom: -20px;
    }
  }

  & .adMedia {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    & > video {
      position: relative;
      width: 100%;
      height: 750px;
      object-fit: cover;
    }

    & > div {
      position: relative;
      width: 80%;
      padding: 20px;
      background: #fff;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin-top: -30px;
      z-index: 1;
      row-gap: 14px;
      @media screen and (orientation: portrait) {
        width: 100%;
        nmargin-top: 0;
        row-gap: 10px;
      }

      & > h3 {
        font-family: "Inconsolata", serif;
        font-size: 27px;
        font-weight: 700;
        line-height: 32px;
        letter-spacing: 0.68px;
        max-width: 50%;
        text-align: center;
        @media screen and (orientation: portrait) {
          font-size: 18px;
          max-width: 100%;
          line-height: 21px;
          font-weight: 600;
        }
      }
    }
    @media screen and (orientation: portrait) {
      video {
        height: 450px;
      }
    }
  }

  & .imgWrap {
    width: 100%; 
    display: flex;
    align-items: center; 
    justify-content: center;

    & > .ceo_logo {
      width: 100%; 
      max-width: 330px; 
      height: auto;
      @media screen and (orientation: portrait) {
        max-width: 270px
      }
    }
    @media screen and (orientation: portrait) {
      width: auto;
      display: block;
    }
  }
`;

export const Content = styled.div`
  position: relative;
  width: 100%;
  max-width: 1300px;
  padding-top: 15px;
  box-sizing: border-box;
  font-size: 14px;
  z-index: 9;

  & .heroDesktop {
    display: block;
    @media screen and (orientation: portrait) {
      display: none;
    }
  }

  & .heroMobile {
    display: none;
    @media screen and (orientation: portrait) {
      display: block;
    }
  }

  & > .topText {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    row-gap: 30px;
    align-items: center;

    & > h1 {
      width: 100%;
      max-width: 620px;
      color: #000;
      font-size: 60px;
      -webkit-text-stroke: 1px #000;
      text-stroke: 1px #000;
      font-weight: 900;
      line-height: 57px;
      letter-spacing: 1px;
      @media screen and (orientation: portrait) {
        font-size: 40px;
        line-height: 40px;
        letter-spacing: 0;
      }
    }

    & > .headlineH2 {
      width: 100%;
      max-width: 1000px;
      color: #000;
      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 2px;

      @media screen and (orientation: portrait) {
        position: relative;
        width: auto;
        letter-spacing: 1px;
        font-size: 12px;
        margin-top: 10px;
        line-height: 17px;
      }
    }

    & > .btn {
      width: max-content;
      height: 45px;
      color: rgb(255, 255, 255);
      text-align: center;
      font-family: Inconsolata, serif;
      font-size: 13px;
      font-weight: 500;
      letter-spacing: 0.77px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      padding-left: 30px;
      padding-right: 30px;
      border-radius: 50px;
      border-width: 1px;
      border-style: solid;
      border-color: rgb(221, 221, 221);
      border-image: initial;
      background: rgb(0, 0, 0);
      text-decoration: none;
    }

    & > p {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 385px;
      color: #000;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 2px;

      @media screen and (orientation: portrait) {
        position: relative;
        width: auto;
        margin-top: 30px;
      }
    }

    @media screen and (orientation: portrait) {
      flex-direction: column;
      margin-top: 0;
    }
  }

  & .client_hover:hover {
    opacity: 0.5;
  }

  @media screen and (orientation: portrait) {
    // max-width: 300px;
    max-width: 100%;
    padding-top: 0;
  }
`;

export const FooterContent = styled.div`
  width: 100%;
  & > .footer {
    margin-top: 80px;
    margin-bottom: 40px;

    @media screen and (orientation: portrait) {
      margin-top: 50px;
    }
  }
`;

export const MediumBlockBreaking = styled.div`
  width: 100%;
  max-width: 1600px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 70px;
  row-gap: 20px;
  margin-top: 30px;
  &::last-of-type {
    margin-bottom: 0;
  }

  @media screen and (orientation: portrait) {
    display: flex;
    padding: 0;
    padding-bottom: 0;
    box-sizing: border-box;
    flex-direction: column;
    row-gap: 30px;
    margin-top: 0;
  }
`;

export const MediumBlockBreakingStories = styled.div`
  width: 100%;
  max-width: 1600px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 0;
  row-gap: 20px;
  margin-bottom: 7px;
`;

export const MediumBlockStoriesPage = styled.div`
  width: 100%;
  max-width: 1600px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 0;
  row-gap: 7px;
  column-gap: 7px;

  @media screen and (orientation: portrait) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const SmallBlockBreaking = styled.div`
  width: 100%;
  max-width: 1600px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 25px;
  row-gap: 20px;
  margin-top: 30px;
  &::last-of-type {
    margin-bottom: 0;
  }

  @media screen and (orientation: portrait) {
    display: grid;
  grid-template-columns: repeat(2, 1fr);
    // display: flex;
    padding: 0;
    padding-bottom: 0;
    box-sizing: border-box;
    flex-direction: column;
    row-gap: 30px;
    margin-top: 0;
  }
`;
export const SmallfourBlockBreaking = styled.div`
  width: 100%;
  max-width: 1600px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 10px;
  row-gap: 10px;
  margin-top: 30px;
  &::last-of-type {
    margin-bottom: 0;
  }

  @media screen and (orientation: portrait) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    padding: 0;
    padding-bottom: 0;
    box-sizing: border-box;
    flex-direction: column;
    row-gap: 30px;
    margin-top: 0;
  }
`;

export const ExtraSmallBlockBreaking = styled.div`
  width: 100%;
  max-width: 1600px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  column-gap: 10px;
  row-gap: 10px;
  margin-top: 30px;
  &::last-of-type {
    margin-bottom: 0;
  }

  @media screen and (orientation: portrait) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    padding: 0;
    padding-bottom: 0;
    box-sizing: border-box;
    flex-direction: column;
    row-gap: 30px;
    margin-top: 0;
  }
`;

export const DoubleExtraSmallBlockBreaking = styled.div`
  width: 100%;
  max-width: 1600px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 10px;
  row-gap: 10px;
  margin-top: 20px;
  &::last-of-type {
    margin-bottom: 0;
  }

  @media screen and (orientation: portrait) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 10px;
    row-gap: 10px;
    padding: 0;
    padding-bottom: 0;
    box-sizing: border-box;
    flex-direction: column;
    margin-top: 0;
  }
`;

export const ApealingText = styled.div`
  width: 100%;
  max-width: 1600px; 
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: flex-start;
  flex-direction: column;
  padding: 15px;
  box-sizing: border-box;
  row-gap: 10px;
  column-gap: 10px;

& > p, a {
  max-width: 500px;
  font-size: 16px;
  font-weight: 300;
  line-height: 30px;
  color: #000;
  @media screen and (orientation: portrait) {
    max-width: 100%;
    font-size: 14px;
    line-height: 23px;
    font-weight: 300;
  }
}
& > .contacts {
  display: flex;
  flex-direction: column;
  width: 100%;
  row-gap: 12px;
  & > a {
    text-decoration: underline;
  }
}
@media screen and (orientation: portrait) {
  padding: 12px;
  row-gap: 20px;
  grid-template-columns: repeat(1, 1fr);
}
`
export const MagazineIssue = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  column-gap: 10px;
  margin-top: 10px;
  padding-left: 50px;
  padding-right: 50px;
  box-sizing: border-box;

  & > img {
    width: 100%;
    height: auto;
    @media screen and (orientation: portrait) {
      max-width: 100%;
      padding-bottom: 10px;
    }
  }
  @media screen and (orientation: portrait) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    margin-top: 0;
    padding: 0;
  }
`;

export const Ceoinfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  align-items: center;
  justify-content: center;
  margin-top: -20px;

  & span {
    font-size: 14px;
  }

  & .btn {
    border: 1px solid #000;
    color: #000;
    padding: 14px;
    width: max-content;
    text-align: center;
    text-decoration: none;
    font-size: 14px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    @media screen and (orientation: portrait) {
      padding: 11px;
      font-size: 12px;
    }
  }

  & .ceo_logo {
    width: 180px;
    height: auto;
    margin-bottom: 10px;
  }
`;

export const BtnMore = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: -33px;
  margin-bottom: 33px;
  column-gap: 10px;
  & > .btn {
    border: 1px solid #000;
    color: #000;
    padding: 14px;
    width: 100%;
    text-align: center;
    max-width: 200px;
    text-decoration: none;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-size: 14px;
    @media screen and (orientation: portrait) {
      padding: 11px;
      font-size: 12px;
    }
  }
  @media screen and (orientation: portrait) {
    margin-top: 0;
    margin-bottom: 23px;
    column-gap: 10px;
  }
`;

export const BtnEditorial = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 33px;
  column-gap: 10px;
  & > .btn {
    border: 1px solid #000;
    color: #000;
    padding: 14px;
    width: 100%;
    text-align: center;
    max-width: 220px;
    text-decoration: none;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-size: 14px;
    @media screen and (orientation: portrait) {
      padding: 11px;
      font-size: 12px;
    }
  }
  @media screen and (orientation: portrait) {
    margin-top: 0px;
    margin-bottom: 23px;
    column-gap: 10px;
  }
`;

export const TopStory = styled.div`
  width: 100%;
  max-width: 1600px; 
  display: flex;

  & > .story25 {
    width: 22%;
  }

  & > .story50 {
    width: 60%; 
    padding-left: 20px;
    padding-right: 20px;
  }

  & > .story25Dual {
    width: 30%;
  }

  & > .storyDual {
    width: 60%; 
    padding-left: 10px;
    padding-right: 10px;
  }
  @media screen and (orientation: portrait) {
    display: none;
  }
`;

export const TopStoryD = styled.div`
  width: 100%;
  display: none;
  @media screen and (orientation: portrait) {
    display: block;
  }
`;

export const SeriesH = styled.h2`
  width: 100%;
  text-align: center;
  letter-spacing: 1px;
  @media screen and (orientation: portrait) {
    font-size: 25px !important;
    margin-top: 30px;
    margin-bottom: 20px;
  }
`
export const ExpTitle = styled.h2`
  width: 100%;
  text-align: center;
  text-transform: uppercase;
  padding: 20px;
  box-sizing: border-box;
  padding-top: 35px;
  font-weight: 300;
  font-size: 25px;
  letter-spacing: 2px;
  @media screen and (orientation: portrait) {
    font-size: 20px;
    letter-spacing: 1px;
  }
`